var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 139,
    viewBox: "0 0 113 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.757 105.417V113.678C110.757 113.705 110.735 113.727 110.707 113.727H60.6642M110.757 105.417H74.9763M110.757 105.417L106.962 87.4114M2.49219 105.417V113.678C2.49219 113.705 2.5143 113.727 2.54157 113.727H52.1231M2.49219 105.417H14.9576M2.49219 105.417L6.44858 87.4114M22.3445 105.417H38.9651M71.5137 53.9395H99.8671C99.8905 53.9395 99.9106 53.9558 99.9155 53.9787L103.435 70.6754M71.5137 53.9395L74.9763 105.417M71.5137 53.9395H42.6586M74.9763 105.417H38.9651M42.6586 53.9395H13.8431C13.8199 53.9395 13.7999 53.9556 13.7949 53.9782L10.126 70.6754M42.6586 53.9395L38.9651 105.417M6.44858 87.4114H106.962M6.44858 87.4114L10.126 70.6754M106.962 87.4114L103.435 70.6754M103.435 70.6754H10.126M52.1231 113.727V128.27M52.1231 113.727H60.6642M52.1231 128.27H35.0902C35.0629 128.27 35.0408 128.292 35.0408 128.32V136.35M52.1231 128.27H60.6642M12.6492 136.35H78.2081M99.9072 136.35H78.2081M60.6642 113.727V128.27M60.6642 128.27H78.1587C78.186 128.27 78.2081 128.292 78.2081 128.32V136.35",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5125,
    cy: 22.3133,
    r: 8.18176,
    stroke: "#B1B1B1",
    strokeWidth: 3.95052
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5117 2V7.30935",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5117 38.4727V43.782",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2812 8.11914L67.527 11.8734",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4922 33.9102L41.7379 37.6644",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3984 22.8926L72.0891 22.8926",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9258 22.8926L35.6164 22.8926",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2812 37.6621L67.527 33.9078",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4922 11.873L41.7379 8.11877",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.8d653e9f974935d88f95ee533f9895e5.svg";
export { ForwardRef as ReactComponent };